<template>
  <div>
    <div @click="trigger('cancel')" class="vm--overlay"></div>
    <div class="chore-assignment-container">
      <div class="chore-assignment-title">{{ title }}</div>
      <div class="create-assignment-error" v-if="showErrorMessage">
        <img src="../../assets/error_red.png" />
        <span>{{ errorMessage }}</span>
      </div>
      <div class="chore-assignment-selector">
        <label for="property-selector"
          >Property
          <label class="error-label" v-if="!isValid && !selProperty"
            >* Missing</label
          >
        </label>
        <select
          class="property-selector"
          name="property-selector"
          v-model="selProperty"
          @change="onChangeProperty"
        >
          <option selected :value="null">Select Property</option>
          <option
            v-for="property of properties"
            :key="'property-' + property.uuid"
            :value="property.uuid"
          >
            {{ property.internalName }}
          </option>
        </select>
      </div>
      <div class="chore-assignment-selector">
        <label for="chore-selector"
          >Chore
          <label class="error-label" v-if="!isValid && !selChore"
            >* Missing</label
          >
        </label>
        <select class="chore-selector" name="chore-selector" v-model="selChore">
          <option :value="null">Select Chore</option>
          <option
            v-for="(chore, index) of filteredChores"
            :key="'chore-assign-' + chore.uuid + 'index' + index"
            :value="chore.uuid"
          >
            {{ chore.name }}
          </option>
        </select>
      </div>
      <div class="chore-assignment-selector-container">
        <div class="chore-assignment-selector-subcontainer">
          <label for="housemate-selector"
            >Housemate
            <label class="error-label" v-if="!isValid && !selHousemate"
              >* Missing</label
            >
          </label>
          <div class="chore-assignment-small-selector">
            <select
              class="housemate-selector"
              name="housemate-selector"
              v-model="selHousemate"
            >
              <option selected :value="null">Select Housemate</option>
              <option
                v-for="(person, index) of housemates"
                :key="'housemate-' + index"
                :value="person"
              >
                {{ person.housemate.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="chore-assignment-selector-subcontainer">
          <label for="date-selector"
            >Date
            <label
              class="error-label"
              v-if="!isValid || !validTime || (!isValid && !time)"
            >
              * {{ timeErrorMessage }}
            </label>
          </label>
          <date-picker
            format="YYYY-MM-DD"
            placeholder="Select Date"
            value-type="format"
            v-model="time"
            id="date-picker"
            :disabled-date="disableBeforeToday"
          />
        </div>
      </div>

      <div class="chore-assignment-buttons-container">
        <button
          class="chore-assignment-cancel-button"
          @click="trigger('cancel')"
        >
          Cancel
        </button>
        <button
          class="chore-assignment-assign-button"
          @click="trigger(triggerSignal)"
        >
          {{ saveBtnText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import calls from '@/api/calls.js'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import {
  getCaliforniaTodayFormatted,
  isDateBeforeCaliforniaToday
} from '@/functions/choreDateFilter'

export default {
  props: {
    chores: {
      type: Array,
      default: () => {
        return []
      }
    },
    inputChore: {
      type: Object,
      default: () => {
        return {}
      }
    },
    inputProperty: {
      type: Object,
      defaault: () => {
        return {}
      }
    },
    assignment: {
      type: Object,
      defaault: () => {
        return {}
      }
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      properties: [],
      filteredChores: [],
      selProperty: null,
      selChore: null,
      selHousemate: null,
      selAssignment: null,
      time: '',
      title: 'Assign Chore',
      saveBtnText: 'Assign Chore',
      triggerSignal: 'create',
      oldSelProperty: null,
      oldSelHousemate: null,
      oldSelChore: null,
      oldTime: '',
      isValid: true,
      validTime: true,
      timeErrorMessage: '',
      errorMessage: '',
      showErrorMessage: false
    }
  },
  asyncComputed: {
    async housemates() {
      if (this.selProperty != null) {
        const { data, message } = await calls.GET(
          'housemates/from/now/on',
          this.selProperty
        )
        return data
      } else return []
      // const { data, message } = await calls.GET('housemates')
      // return data
    }
  },
  methods: {
    disableBeforeToday(date) {
      return isDateBeforeCaliforniaToday(date)
    },
    async trigger(signal) {
      this.doValidate()
      if (signal == 'create' && this.isValid) {
        let property_selected = this.properties.filter(
          (p) => p.uuid == this.selProperty
        )[0]
        const { message, data } = await calls.POST(
          `assignment/${this.selHousemate.housemate.uuid}/${this.selChore}`,
          {
            date: moment(this.time)
              .utcOffset(property_selected.utcoffset)
              .toISOString(),
            originalDate: moment(this.time)
              .utcOffset(property_selected.utcoffset)
              .toISOString()
          }
        )
        this.$emit(signal)
      } else if (signal == 'cancel') {
        this.selProperty = null
        this.selChore = null
        this.$emit(signal)
      } else if (signal === 'edit' && this.isValid && this.validTime) {
        let property_selected = this.properties.filter(
          (p) => p.uuid == this.selProperty
        )[0]
        if (this.oldSelProperty != this.selProperty) {
          await calls.DELETE(
            `assignment/${this.oldSelHousemate.housemate.uuid}/${this.oldSelChore}`
          )
          const { message, data } = await calls.POST(
            `assignment/${this.selHousemate.housemate.uuid}/${this.selChore}`,
            {
              date: moment(this.time)
                .utcOffset(property_selected.utcoffset)
                .toISOString()
            }
          )
        } else {
          let property_selected = this.properties.filter(
            (p) => p.uuid == this.selProperty
          )[0]
          if (
            this.oldSelHousemate.housemate.uuid !==
            this.selHousemate.housemate.uuid
          ) {
            const { message, data } = await calls.PUT(
              'assignment/reassign/housemate',
              `${this.oldSelHousemate.housemate.uuid}/${this.oldSelChore}`,
              {
                date: moment(this.time)
                  .utcOffset(property_selected.utcoffset)
                  .toISOString(),
                newGuestID: this.selHousemate.housemate.uuid
              }
            )
            if (message) {
              this.$notify({
                group: 'rent-mgt-notification',
                type: 'error',
                text: message
              })
            }
          }
          if (this.oldSelChore !== this.selChore) {
            const { message, data } = await calls.PUT(
              'assignment/reassign/chore',
              `${this.selHousemate.housemate.uuid}/${this.oldSelChore}`,
              {
                date: moment(this.time)
                  .utcOffset(property_selected.utcoffset)
                  .toISOString(),
                newChoreID: this.selChore
              }
            )
            if (message) {
              this.$notify({
                group: 'rent-mgt-notification',
                type: 'error',
                text: message
              })
            }
          }
          if (this.oldTime !== this.time) {
            const { message, data } = await calls.PUT(
              'assignment/redate',
              `${this.selHousemate.housemate.uuid}/${this.selChore}`,
              {
                date: moment(this.time)
                  .utcOffset(property_selected.utcoffset)
                  .toISOString()
              }
            )
            if (message) {
              this.$notify({
                group: 'rent-mgt-notification',
                type: 'error',
                text: message
              })
            }
          }
        }
        this.$emit('cancel', { afterEdit: true })
      }
    },
    doValidate() {
      if (
        !this.selProperty ||
        !this.selChore ||
        !this.selHousemate ||
        !this.time
      ) {
        this.timeErrorMessage = 'Missing'
        this.isValid = false
      } else {
        for (let i in this.selHousemate.rentals) {
          if (
            moment(this.time).isBetween(
              moment(this.selHousemate.rentals[i].arrival).format('YYYY-MM-DD'),
              moment(this.selHousemate.rentals[i].departure).format(
                'YYYY-MM-DD'
              )
            )
          ) {
            this.isValid = true
            this.validTime = true
            this.showErrorMessage = false
            break
          } else {
            this.isValid = false
            this.validTime = false
            this.timeErrorMessage = 'Select a different date'
            this.showErrorMessage = true
            this.errorMessage =
              "CAN'T assign a chore to someone who will not be staying at the property on the selected date"
          }
        }
      }
    },
    async onChangeProperty() {
      if (this.oldSelProperty !== this.selProperty) {
        this.selChore = null
        this.selHousemate = null
      } else if (this.oldSelProperty === this.selProperty) {
        this.selChore = this.oldSelChore
        this.selHousemate.housemate.uuid = this.oldSelHousemate.housemate.uuid
      }
      await this.updateChores()
    },
    async updateChores() {
      {
        const { data, message } = await calls.GET(
          `chores/from/a/${this.selProperty}`
        )
        this.filteredChores = data
      }
    },
    async showEdit(data) {
      this.$emit('loading', true)
      try {
        this.filteredChores = this.chores
        this.oldTime = moment(data.date).format('YYYY-MM-DD')
        this.time = moment(data.date).format('YYYY-MM-DD')
        this.selChore = data.choreId
        this.selProperty = data.propertyId
        this.title = 'Edit Chore'
        this.saveBtnText = 'Save Changes'
        this.selHousemate = data.userId
        this.oldSelHousemate = data.userId
        this.oldSelChore = data.choreId
        this.oldSelProperty = data.propertyId
        this.triggerSignal = 'edit'
        await this.updateChores()
      } finally {
        this.$emit('loading', false)
      }
    }
  },
  async created() {
    this.$emit('loading', true)
    try {
      if (this.inputChore != null && this.inputProperty != null) {
        this.selProperty = this.inputProperty.uuid
        this.$nextTick()
        this.selChore = this.inputChore.uuid
      }
      if (this.chores) {
        this.filteredChores = this.chores
      }
      this.time = getCaliforniaTodayFormatted()

      const { data, message } = await calls.GET('properties')
      this.properties = data
    } finally {
      this.$emit('loading', false)
    }
  }
}
</script>

<style scoped>
label {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  margin-bottom: 5px;
}

select {
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  height: 40px;
}

.chore-assignment-screen {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 2;
}

.chore-assignment-container {
  position: fixed;
  top: calc(50% - 500px / 2);
  left: calc(50% - 512px / 2);
  background-color: white;
  border-radius: 4px;
  width: 512px;
  height: 370px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: baseline;
  padding: 32px;
}

.chore-assignment-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 22px;
  color: #66b015;
}

.chore-assignment-selector,
.chore-assignment-selector-subcontainer {
  padding-right: 10px;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  text-align: left;
}

.chore-assignment-selector select {
  cursor: pointer;
  margin-top: 5px;
}

.chore-assignment-selector-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.chore-assignment-selector-container select {
  cursor: pointer;
  margin-top: 5px;
}

.chore-assignment-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 80%;
  padding-left: 20%;
}

.chore-assignment-cancel-button,
.chore-assignment-assign-button {
  border: 4px;
  width: 176px;
  height: 48px;
  line-height: 48px;
}

.chore-assignment-cancel-button:hover,
.chore-assignment-assign-button:hover {
  cursor: pointer;
}

.chore-assignment-cancel-button {
  background: #ffffff;
  border: 1px solid #767675;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #767675;
}

.chore-assignment-assign-button {
  background: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
}

.housemate-selector {
  width: 200px;
}

.error-label {
  color: red;
}

.create-assignment-error {
  padding: 12px;
  width: 100%;
  color: red;
  background: rgba(223, 0, 15, 0.05);
  border-radius: 6px;
}

.create-assignment-error span {
  margin-left: 12px;
  color: #df000f;
  font-family: Montserrat;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}

.mx-datepicker {
  padding-right: 10px;
  margin-top: 5px;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .chore-assignment-container {
    position: fixed;
    top: 15%;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    max-height: 70vh;
    overflow-y: auto;
    transform: none;
    padding: 20px;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    border-radius: 0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  }

  .chore-assignment-title {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 16px;
    font-weight: 900;
    color: #66b015;
    text-align: center;
  }

  .chore-assignment-selector,
  .chore-assignment-selector-subcontainer {
    padding-right: 0;
    margin-bottom: 14px;
  }

  .chore-assignment-selector select {
    height: 44px;
    font-size: 16px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 2px solid #e1e5e9;
    transition: border-color 0.2s ease;
  }

  .chore-assignment-selector select:focus {
    border-color: #66b015;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 176, 21, 0.1);
  }

  .chore-assignment-selector-container {
    flex-direction: column;
    gap: 16px;
  }

  .chore-assignment-selector-subcontainer {
    width: 100%;
  }

  .housemate-selector {
    width: 100%;
  }

  .chore-assignment-buttons-container {
    flex-direction: column;
    width: 100%;
    padding-left: 0;
    gap: 12px;
    margin-top: 24px;
    position: sticky;
    bottom: 0;
    background: white;
    padding: 16px 0;
    border-top: 2px solid #f0f0f0;
  }

  .chore-assignment-cancel-button,
  .chore-assignment-assign-button {
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
  }

  .chore-assignment-cancel-button {
    border: 2px solid #e1e5e9;
    background: white;
    color: #666;
  }

  .chore-assignment-cancel-button:hover {
    border-color: #66b015;
    color: #66b015;
  }

  .chore-assignment-assign-button {
    background: #66b015;
    border: 2px solid #66b015;
    color: white;
  }

  .chore-assignment-assign-button:hover {
    background: #5a9b12;
    border-color: #5a9b12;
    transform: translateY(-1px);
  }

  .create-assignment-error {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 6px;
    background: rgba(223, 0, 15, 0.05);
  }

  .create-assignment-error span {
    font-size: 14px;
    line-height: 20px;
  }

  .mx-datepicker {
    padding-right: 0;
    margin-top: 6px;
  }

  .mx-datepicker >>> .mx-input {
    height: 44px;
    font-size: 16px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 2px solid #e1e5e9;
    transition: border-color 0.2s ease;
  }

  .mx-datepicker >>> .mx-input:focus {
    border-color: #66b015;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 176, 21, 0.1);
  }

  /* Enhanced scrolling experience */
  .chore-assignment-container::-webkit-scrollbar {
    width: 6px;
  }

  .chore-assignment-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .chore-assignment-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .chore-assignment-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
}

@media (max-width: 480px) {
  .chore-assignment-container {
    position: fixed !important;
    top: 10% !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    max-width: -webkit-fill-available !important;
    max-height: 80vh !important;
    padding: 18px !important;
    overflow-y: auto !important;
    border-radius: 6px !important;
  }

  .chore-assignment-title {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 14px;
  }

  .chore-assignment-selector,
  .chore-assignment-selector-subcontainer {
    margin-bottom: 12px;
  }

  .chore-assignment-selector select {
    height: 40px;
    font-size: 16px;
    padding: 8px 12px;
    border-radius: 6px;
  }

  .chore-assignment-selector-container {
    gap: 14px;
  }

  .chore-assignment-buttons-container {
    gap: 8px;
    margin-top: 20px;
    padding: 14px 0;
  }

  .chore-assignment-cancel-button,
  .chore-assignment-assign-button {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 6px;
  }

  .mx-datepicker >>> .mx-input {
    height: 40px;
    font-size: 16px;
    padding: 8px 12px;
    border-radius: 6px;
  }
}
</style>
